import script from "./sales_templates.vue?vue&type=script&setup=true&lang=js"
export * from "./sales_templates.vue?vue&type=script&setup=true&lang=js"

import "./sales_templates.vue?vue&type=style&index=0&id=fde86c6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fde86c6c"]])

export default __exports__